import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
/**
 * Missions — the 9 validation jobs Periscan ships.
 *
 * Was a 3x3 lucide-icon card grid (Target, Sparkles, CheckCircle2, Users,
 * Briefcase, TrendingUp, Building, Network, Shield). Now an editorial
 * numbered list, same content, no icon boxes.
 */
const missions = [{
  name: 'Attack-Path Report',
  desc: 'Find the top realistic paths across cloud, identity, SaaS, code, external exposure, and internal signals.'
}, {
  name: 'AI App Validation',
  desc: 'Validate LLM apps, RAG, copilots, agents, and AI workflows for misuse, leakage, and unsafe access.'
}, {
  name: 'Fix Verification',
  desc: 'Re-test remediated issues. Prove whether risk is actually closed.'
}, {
  name: 'Customer Security Review',
  desc: 'Generate evidence for enterprise customers, questionnaires, and trust conversations.'
}, {
  name: 'Cyber Insurance Readiness',
  desc: 'Prepare evidence around validation, remediation history, control gaps, and risk reduction.'
}, {
  name: 'Executive Risk Brief',
  desc: 'Translate validation results into plain-English business risk and action plans.'
}, {
  name: 'MSSP Client Report',
  desc: 'Client-ready summaries, remediation plans, QBR content, and proof of security progress.'
}, {
  name: 'Internal Exposure Review',
  desc: 'Use an optional internal runner to validate reachability and risky internal paths.'
}, {
  name: 'Control Validation',
  desc: 'Safely test whether controls detect, block, or miss defined validation activity.'
}];
export function Missions() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-1048">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1049">
        <SectionLabel number="—" label="Missions" className="mb-8" data-id="element-1050" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20" data-id="element-1051">
          <div className="lg:col-span-8" data-id="element-1052">
            <SectionHeading size="xl" data-id="element-1053">
              Choose a mission.
              <br data-id="element-1054" />
              <span className="text-white/40" data-id="element-1055">Get proof.</span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-4 lg:pt-4" data-id="element-1056">
            <p className="text-lg text-white/60 leading-relaxed" data-id="element-1057">
              Periscan organizes security work into validation missions —
              focused workflows that produce specific evidence.
            </p>
          </div>
        </div>

        <ol className="border-t border-white/5" data-id="element-1058">
          {missions.map((m, i) => <motion.li key={m.name} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.04
        }} className="border-b border-white/5 py-9 grid grid-cols-12 gap-6 items-baseline" data-id="element-1059">
              <span className="col-span-12 md:col-span-1 font-mono text-sm text-[#1a8fd4]/70 tracking-[0.2em]" data-id="element-1060">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="col-span-12 md:col-span-4 text-2xl md:text-3xl text-white font-semibold tracking-tight leading-snug" data-id="element-1061">
                {m.name}
              </h3>
              <p className="col-span-12 md:col-span-7 text-base md:text-lg text-white/65 leading-relaxed max-w-2xl" data-id="element-1062">
                {m.desc}
              </p>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}